jQuery(function ($) {
  const sections = $('[data-teaserGrid]');

  $.each(sections, function () {
    const section = $(this);

    const masonry = section.find('.grid').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true
    });

    // Filter mechanic by tag
    const buttonTags = section.find('.filter [data-tag]');
    const selectTags = section.find('.filter [data-select-tag]');

    function filterItemsByTag (element, elementType) {
      const items = section.find('.grid-item');

      if (elementType === 'button') {
        chosenValue = element.data('tag');
      } else {
        if (selectTags.val() !== 'all') {
          chosenValue = parseInt(selectTags.val());
        } else {
          chosenValue = selectTags.val();
        }
      }

      // Update active class on buttons
      buttonTags.removeClass('is-active');
      buttonTags.filter('[data-tag="' + chosenValue + '"]').addClass('is-active');

      // Update select
      selectTags.val(chosenValue).blur();

      // Clear items of classes
      items.removeClass('is-filtered-by-tag is-matched-by-tag');

      // Filter items
      items.each(function() {
        const item = $(this);

        item.addClass('is-filtered-by-tag');

        if (chosenValue === 'all') {
          item.addClass('is-matched-by-tag');
        } else if (chosenValue !== false && $.inArray(chosenValue, item.data('tag')) !== -1) {
          item.addClass('is-matched-by-tag');
        }
      });

      // Display error
      displayError();
    }

    buttonTags.on('click', function (e) {
      e.preventDefault();

      filterItemsByTag($(this), 'button');
    });

    selectTags.on('change', function (e) {
      e.preventDefault();

      filterItemsByTag($(this), 'select');
    });

    // Filter mechanic by product
    const buttonProducts = section.find('.filter [data-product]');
    const selectProducts = section.find('.filter [data-select-product]');

    function filterItemsByProduct (element, elementType) {
      const items = section.find('.grid-item');

      if (elementType === 'button') {
        chosenValue = element.data('product');
      } else {
        if (selectProducts.val() !== 'all') {
          chosenValue = parseInt(selectProducts.val());
        } else {
          chosenValue = selectProducts.val();
        }
      }

      // Update active class
      buttonProducts.removeClass('is-active');
      buttonProducts.filter('[data-product="' + chosenValue + '"]').addClass('is-active');

      // Update select
      selectProducts.val(chosenValue).blur();

      // Clear items of classes
      items.removeClass('is-filtered-by-product is-matched-by-product');

      // Filter items
      items.each(function() {
        const item = $(this);

        item.addClass('is-filtered-by-product');

        if (chosenValue === 'all') {
          item.addClass('is-matched-by-product');
        } else if (chosenValue !== false && $.inArray(chosenValue, item.data('product')) !== -1) {
          item.addClass('is-matched-by-product');
        }
      });

      // Display error
      displayError();
    }

    buttonProducts.on('click', function (e) {
      e.preventDefault();

      filterItemsByProduct($(this), 'button');
    });

    selectProducts.on('change', function (e) {
      e.preventDefault();

      filterItemsByProduct($(this), 'select');
    });

    // Display error if no matches found
    function displayError() {
      masonry.masonry('layout');

      const error = section.find('.filter [data-error]');
      const items = section.find('.grid-item');
      let matches = 0;

      items.each(function () {
        if ($(this).is(':visible')) {
          matches++;
        }
      });

      if (matches > 0) {
        error.hide();
      } else {
        error.show();
      }
    }

  });
});
